import { Image } from "@shopify/hydrogen";
import clsx from "clsx";

const DARK_LOGO =
  "https://cdn.sanity.io/images/15oppjc2/production/89a9bb7af7976e5c1cc6c6b02c9586bf66e57471-446x62.png";
const LIGHT_LOGO =
  "https://cdn.sanity.io/images/15oppjc2/production/aa1b3cf1c79560d984a0ef0de88b4307027c0407-446x62.png";

// The logo is two images rather than text, so it can't inherit the header's
// colour fade. The current one sits fully opaque underneath and the outgoing one
// fades out on top of it, so the swap never dips through transparency. The
// header marks changes that shouldn't fade with `data-colour-instant`.
const SHOWN = "z-0 opacity-100 transition-none";
const HIDDEN =
  "z-10 opacity-0 transition-opacity duration-300 ease-in-out motion-reduce:transition-none [[data-colour-instant]_&]:transition-none";

/** `flip` picks the dark logo, for light backgrounds. */
export default function LogoIcon({ flip = false }: { flip?: boolean }) {
  return (
    <div className="relative z-20 grid w-[130px] lg:w-[223px] lg:self-center">
      <Image
        width="223px"
        height="31px"
        loading="eager"
        data={{ url: DARK_LOGO }}
        className={clsx(
          "relative col-start-1 row-start-1 w-full",
          flip ? SHOWN : HIDDEN
        )}
        alt={flip ? "Goodnature Logo" : ""}
        aria-hidden={!flip}
      />
      <Image
        width="223px"
        height="31px"
        loading="eager"
        data={{ url: LIGHT_LOGO }}
        className={clsx(
          "relative col-start-1 row-start-1 w-full",
          flip ? HIDDEN : SHOWN
        )}
        alt={flip ? "" : "Goodnature Logo"}
        aria-hidden={flip}
      />
    </div>
  );
}
